import { useEffect, useState } from "react";
import { UserPlus } from "lucide-react";
import { api } from "@/api/client";
import ComingSoon from "@/components/ComingSoon";

export default function Leads() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    api.get("/leads").then((r) => setCount(r.data.length)).catch(() => setCount(null));
  }, []);

  return (
    <ComingSoon
      icon={UserPlus}
      title="Лиды"
      description="Заявки с сайта и другие источники"
      note={count === null ? "Полный рабочий процесс с лидами пока не реализован." : `В системе уже ${count} ${count === 1 ? "лид" : "лидов"} — полный рабочий процесс с ними пока не реализован.`}
    />
  );
}
